"use strict";require("./_wks-define")("observable");